import { useContext } from "react";
import UserAuthContext from "./UserAuthContext";

export const useLogOut = (): (() => void) => {
  return useContext(UserAuthContext).logOut;
};
